import React from 'react';
import { useTranslation } from 'react-i18next';
import { IProps } from './types';
import ErrorBoundaryUI from '../../error-boundary/error-boundary';
import ErrorBoundaryCore from '../../error-boundary/error-boundary-core';

const ErrorBoundaryWrapper: React.FC<IProps> = ({ children }) => {
  const { t } = useTranslation();

  return (
    <ErrorBoundaryCore fallback={<ErrorBoundaryUI t={t} />}>
      {children}
    </ErrorBoundaryCore>
  );
};

export default ErrorBoundaryWrapper;
